import { defineStore } from 'pinia';
import { store } from 'quasar/wrappers';
import { createPinia } from 'pinia';

export default store(() => {
  return createPinia();
});

// Re-export the helper for tests that don't pass through Quasar's wrapper.
export { defineStore };
